import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
let CategoryModel = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = belongsTo('organization', {
  inverse: 'categories',
  async: false
}), _dec4 = hasMany('sub_category', {
  inverse: 'category',
  async: false
}), _dec5 = attr('boolean', {
  defaultValue: false
}), _class = class CategoryModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "rank", _descriptor2, this);
    _initializerDefineProperty(this, "organization", _descriptor3, this);
    _initializerDefineProperty(this, "sub_categories", _descriptor4, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "rank", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "organization", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sub_categories", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { CategoryModel as default };
//# sourceMappingURL=category.js.map
